export default {
  path: '/contract',
  component: () => import(/* webpackChunkName: 'layout' */'@/views/contract/layout/index'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'contract',
      component: () => import(/* webpackChunkName: 'user' */'@/views/contract/index')
    },

    //合同台账新增
    {
      path: '/contract/add',
      name: 'contract',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/contract/components/add')
    },

  ]
}
